const STORAGE_KEY = 'submitted_comments';

/**
 * Retrieves submitted comments from localStorage
 * @returns {Object} Map of place UIDs to submission timestamps
 */
function getSubmittedComments() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return {};
    const parsed = JSON.parse(stored);
    return typeof parsed === 'object' && parsed !== null ? parsed : {};
  } catch {
    return {};
  }
}

/**
 * Saves a comment submission to localStorage
 * @param {string} placeUid - The place UID
 * @param {string} submittedAt - ISO8601 timestamp
 */
function saveSubmission(placeUid, submittedAt) {
  const comments = getSubmittedComments();
  comments[placeUid] = submittedAt;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(comments));
}

/**
 * Check for submission data in flash message element and persist to localStorage
 */
function persistSubmissionFromFlash() {
  const flashElement = document.querySelector('[data-submitted-place-uid]');
  if (!flashElement) return;

  const placeUid = flashElement.dataset.submittedPlaceUid;
  const { submittedAt } = flashElement.dataset;
  if (placeUid && submittedAt) {
    saveSubmission(placeUid, submittedAt);
  }
}

(function () {
  persistSubmissionFromFlash();
  const btnDiv = document.querySelector('.js-external-comment-button');
  const infoDiv = document.querySelector(
    '.js-external-comment-submitted-toggle',
  );
  const h1 = document.querySelector('h1');

  if (!btnDiv || !infoDiv || !h1) return;

  const { uid } = h1.dataset;
  if (!uid) return;

  const submittedComments = getSubmittedComments();
  const commentedDate = submittedComments[uid];

  if (!commentedDate) return;

  // Hide comment button and display date
  btnDiv.classList.add('hidden');
  infoDiv.classList.remove('hidden');
  const date = new Date(commentedDate);
  const dateStr = new Intl.DateTimeFormat('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date);
  const timeStr = new Intl.DateTimeFormat('fr-FR', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(date);
  infoDiv.textContent = `Commentaire déposé le ${dateStr} à ${timeStr}.`;
})();
